import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import config from '../configuration/config.json';
import axios from 'axios';
import { useParams, useNavigate } from "react-router-dom";
import { Spinner, Button, Alert, Form, Col, Row } from 'react-bootstrap';
import { Base64 } from 'js-base64';
import './IDProofing.css';
import {UAParser} from 'ua-parser-js';

Base64.extendUint8Array();

function AdditionalInfo() {
    const title = 'goID ID Proofing Portal';
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [variant, setVariant] = useState("info");
    const [scanResult, setScanResult] = useState(null);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [documentNumber, setDocumentNumber] = useState(false);
    let { aid } = useParams();
    const navigate = useNavigate();
    const appMode = localStorage.getItem('AppMode');
     const [osType, setOsType] = useState('Unknown');

    useEffect(() => {
        let daata = localStorage.getItem('scanResult');
        setScanResult(daata);
        let jsonData = JSON.parse(daata);
        setFirstName(jsonData.mrzData.firstName);
        setLastName(jsonData.mrzData.lastName);
        setDocumentNumber(jsonData.mrzData.documentNumber);
           const parser = new UAParser();
        const os = parser.getOS();
       setOsType(os.name.toLowerCase() || 'Unknown');
    }, []);

    async function updateAdditionalInfo() {
        try {
            setIsLoading(true);
            let scanResultJson = JSON.parse(scanResult);
            let mrzJson = scanResultJson.mrzData;
            mrzJson.firstName = firstName;
            mrzJson.lastName = lastName;
            mrzJson.documentNumber = documentNumber;
            let aditionalinfo = {};
            aditionalinfo.mrzJson = mrzJson;
            aditionalinfo.appMode = appMode;
            aditionalinfo.osType = osType;

            let headers = {
                "content-type": "application/json",
                'Authorization': "Bearer " + config.idproofing.token
            };
            const response = await axios.request({
                method: 'POST',
                url: config.idproofing.apibaseurl + "idproofing/ocr/additionalinfo/" + aid,
                headers: headers,
                responseType: 'application/json',
                data: aditionalinfo
            });
            if (response.status == 201) {
                setIsLoading(false);
                navigate('/idproofing/startidproofing/' + aid);

            }
            else {
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setVariant("danger");
                setShow(true);
                setIsLoading(false);
            }
        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else { 
                setErrorMessage(e.message);
            }
            setVariant("danger");
            setShow(true);
            setIsLoading(false);
        }
    };


    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <main className="mainbg">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col bannerdisplay">
                            
                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col scancontentarea">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                        <Form className="d-flex justify-content-center m-4">
                                            <div>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formFirstName">
                                                        <Form.Label>First Name</Form.Label>
                                                        <Form.Control value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formLastName">
                                                        <Form.Label>Last Name</Form.Label>
                                                        <Form.Control value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                    </Form.Group>
                                                </Row>

                                                <Form.Group className="mb-3" controlId="formDocumentNumber">
                                                    <Form.Label>DocumentNumber</Form.Label>
                                                    <Form.Control value={documentNumber} onChange={(e) => setDocumentNumber(e.target.value)} />
                                                </Form.Group>

                                                <Button variant="primary" type="button"
                                                    disabled={isLoading}
                                                    onClick={updateAdditionalInfo}>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading} />
                                                    <span className="px-2">Submit</span>
                                                </Button>
                                            </div>
                                        </Form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Alert show={show} variant={variant} onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Error!</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default AdditionalInfo;
